import t from "./_ListCache.js";
function e() {
  this.__data__ = new t(), this.size = 0;
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_stackClear.js
// module id = 1549
// module chunks = 67